/**
 * @todo this file has reached the point where it is probably worthwhile to break it up soon
 */
/**
 * List of embed generators/types supported by the api, this might be deprecated
 * @deprecated
 */
export const SupportedEmbeds = ['CTA', 'Infoblock', 'Link', 'Listicle'];
/**
 * What product identifiers does the commerce service support, in order of preferred usage.
 *
 * ** THE ORDER OF THIS ARRAY MATTERS!**
 * It is used to construct (and retrieve!) the product from dynamodb.
 */
export const SupportedProductIdentifiers = ['UPC', 'EAN', 'ISBN', 'ASIN', 'SKU', 'MPN', 'Squirrel'];
export const SupportedImagePlatforms = ['tempest'];
export const SupportedLinkWrappers = ['Skimlinks', 'Trackonomics'];
export const TagAssignmentStatuses = ['Created', 'Updated', 'Unchanged', 'Failed'];
export const ListicleItemKeys = [
    'URL',
    'Image URL',
    'Image Alt Text',
    'Image Source',
    'List Item Title',
    'Product Name',
    'Button Title',
    'Body',
];
export const ListicleItemRequiredKeys = ['URL', 'Image URL', 'Image Alt Text', 'Product Name'];
/**
 * Result statuses for Squirrel items when not complete
 */
export const SquirrelSearchByCodeStatuses = [
    /**The request wasn't picked up yet. */
    'Pending',
    /**The product was rejected by Squirrel because the code is invalid. */
    'Rejected',
    /**Squirrel is fetching this product on all retailers. */
    'PendingSearch',
    /**Squirrel got too many results for the specified code,
     * and wasn't able to do a valid match, please use a different code for the same product. */
    'ExcessiveResults',
    /**Squirrel wasn't able to find any match for the provided code.
     * Please try adding more retailers to your Squirrel account to increase the search area for Squirrel. */
    'NotFound',
    /**It's a new request, and Squirrel will fulfill it in the backend. */
    'Caching',
    /**Squirrel doesn't know that product,
     * it is being added to the Database to find prices/ codes/ cross-country matches. */
    'CheckingLater',
];
/**
 * Map of squirrel statuses to commerce api request statuses
 *
 * This has to manually generate the type as it is would be a circular
 * dependency otherwise
 */
export const SquirrelStatusCodeToCommerceStatusCodeMap = {
    Pending: 'Pending',
    Rejected: 'Error',
    PendingSearch: 'Pending',
    ExcessiveResults: 'Error',
    NotFound: 'NotFound',
    Caching: 'Pending',
    CheckingLater: 'Pending',
};
/**
 * List of statuses that commerce API requests can have.
 *
 * Pending: there is something incomplete about the request
 * Complete: the request is complete without any errors
 * Error: there was an error on the request
 * CompleteWithError: The request completed at least partially, but encountered at least one error
 */
export const CommerceApiRequestStatuses = [
    'Pending',
    'NotFound',
    'Complete',
    'Error',
    'CompleteWithError',
];
/**
 * Header name for the siteId value in the Commerce API auth
 * @see CommerceApiV1Auth
 */
export const AuthSiteIdHeaderName = 'X-SiteIdAuth';
/**
 * Header name for the Commerce API auth token (for use in request)
 * @see CommerceApiV1Auth
 */
export const AuthTokenHeaderName = 'X-SiteAuthToken';
/**
 * Temporarily hardcoded merchant id mapping, exploded
 * @deprecated
 */
export const MerchantIdMapping = {};
Object.entries({
    '10889': 'Target',
    '30432': "Dick's Sporting Goods",
    '29818': 'Zappos',
    '27976': 'REI',
    '59 9419': 'Amazon',
    '29362 11487': 'Walmart',
    '31595 30955 11202 31594': 'Nordstrom',
    '30367 11195': "Macy's",
}).forEach(([ids, merchantName]) => ids.split(' ').forEach((id) => (MerchantIdMapping[id] = merchantName)));
/**
 * Temporarily hardcoded affiliate id mapping
 * @deprecated
 */
export const AffiliateIdMapping = {
    'amazon-affiliate-1': 'Amazon',
    'amazon-affiliate-2': 'Amazon',
    'squirrel-affiliate-1': 'Squirrel',
    'squirrel-affiliate-2': 'Squirrel',
};
//# sourceMappingURL=constants.js.map